// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M15.4142 1H3V23H11V18.9994H16.2076L15.202 18.004L21 12.2645V6.58579L15.4142 1ZM14.5 7.5V3L19 7.5H14.5Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M23.6632 15.2563L20.8868 18.0047L23.6632 20.7531L22.2562 22.1745L18.0439 18.0047L22.2562 13.835L23.6632 15.2563ZM12.999 21.0002H17.499V23.0002H12.999V21.0002Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-file-code-filled')
export default class FileCodeFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'file-code-filled',
    }
  }
}
